import { SHAPES } from "../shapes";
import type { AppClassProperties, UIAppState } from "../types";
import { renderShapeToolButton } from "./Actions";

// pro100доска: the vertical dock now only surfaces select/pencil/eraser/
// text — "Фигуры" (shapes flyout: rectangle/diamond/ellipse/arrow/line/
// image) and "Ещё" (extra tools flyout: pen mode, hand, lock, frame,
// embed, laser) were dropped from the dock on request. Those tools stay
// reachable by their keyboard shortcuts (R/D/O/A/L/9, H, Q, F, K), just
// without a button here.
export const VerticalToolbar = ({
  appState,
  app,
}: {
  appState: UIAppState;
  app: AppClassProperties;
}) => {
  const selectionShape = SHAPES.find((s) => s.value === "selection")!;
  const freedrawShape = SHAPES.find((s) => s.value === "freedraw")!;
  const eraserShape = SHAPES.find((s) => s.value === "eraser")!;
  const textShape = SHAPES.find((s) => s.value === "text")!;

  return (
    <>
      {renderShapeToolButton(selectionShape, appState, app)}
      {renderShapeToolButton(freedrawShape, appState, app)}
      {renderShapeToolButton(eraserShape, appState, app)}
      {renderShapeToolButton(textShape, appState, app)}
    </>
  );
};
